var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M19 20H5a3 3 0 01-3-3V7a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3z","opacity":".35"}}),_c('path',{attrs:{"d":"M10 13a1 1 0 010 2H6a1 1 0 010-2zm12-5v3H2V8h20z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }